<template>
  <MRow class="my-3 items-center" :gutter="0">
    <MCol v-if="moduleName === $constants.ASSET_SOFTWARE" :size="3">
      <SoftwareTypePicker
        :value="value.swTypeId"
        :disabled="Boolean(disabled || value.softwareLicenseId)"
        :placeholder="disabled ? '---' : undefined"
        @change="handleChange({ swTypeId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            :disabled="Boolean(disabled || value.softwareLicenseId)"
            v-bind="slotData"
            :lable="$tc('software_type')"
            custom-icon
            icon-name="softwareType"
          />
        </template>
      </SoftwareTypePicker>
    </MCol>
    <MCol :size="3">
      <FlotoTechnicianGroupPicker
        :value="value.managedByGroupId"
        :disabled="disabled"
        :placeholder="disabled ? '---' : undefined"
        @change="handleChange({ managedByGroupId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            :disabled="disabled"
            v-bind="slotData"
            :lable="`${$tc('managed_by')} ${$tc('group', 1)}`"
            icon-name="users"
          />
        </template>
      </FlotoTechnicianGroupPicker>
    </MCol>
    <MCol :size="3">
      <FlotoTechnicianPicker
        size="default"
        :value="value.managedById"
        :disabled="disabled"
        :group-id="value.managedByGroupId"
        @change="handleChange({ managedById: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            :disabled="disabled"
            v-bind="slotData"
            :lable="$tc('managed_by')"
            icon-name="vector"
          >
            <template v-slot:icon>
              <FlotoUserAvatar
                :size="34"
                :avatar="(slotData.currentItem || {}).avatar"
                :style="{
                  minWidth: `${24}px`,
                }"
              />
            </template>
          </FlotoDropdownTrigger>
        </template>
      </FlotoTechnicianPicker>
    </MCol>
    <MCol :size="3">
      <AssetGroupPicker
        :as-input="false"
        :value="
          moduleName === $constants.CMDB ? value.ciGroupId : value.assetGroupId
        "
        :module-name="moduleName"
        :placeholder="disabled ? '---' : '---'"
        :disabled="disabled"
        @change="
          handleChange(
            moduleName === $constants.CMDB
              ? { ciGroupId: $event }
              : { assetGroupId: $event }
          )
        "
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            :disabled="disabled"
            v-bind="slotData"
            :lable="
              moduleName === $constants.CMDB
                ? $tc('ci_group')
                : $tc('asset_group')
            "
            icon-name="assetGroup"
            custom-icon
          />
        </template>
      </AssetGroupPicker>
    </MCol>
    <MCol
      v-if="
        (moduleName === $constants.CMDB && value.asset) ||
        (moduleName === $constants.ASSET_HARDWARE && value.ci)
      "
      :size="3"
    >
      <FlotoTriggerView
        custom-icon
        icon-name="hardwareAsset"
        :lable="`${moduleName === $constants.CMDB ? $tc('asset') : $tc('ci')}`"
      >
        <template v-slot:value>
          <AssetPickerDrawer
            clickable
            :module-name="
              moduleName === $constants.CMDB
                ? $constants.ASSET_HARDWARE
                : $constants.CMDB
            "
            :placeholder="disabled ? '---' : undefined"
            :value="value.id"
            disabled
          />
        </template>
      </FlotoTriggerView>
    </MCol>
  </MRow>
</template>

<script>
import AssetPickerDrawer from '@components/data-picker/asset-picker-drawer'
import SoftwareTypePicker from '@components/data-picker/software-type-picker'
import AssetGroupPicker from '@components/data-picker/asset-group-picker'
export default {
  name: 'SecondRow',
  components: { AssetGroupPicker, SoftwareTypePicker, AssetPickerDrawer },
  model: {
    event: 'change',
  },
  props: {
    value: { type: Object, required: true },
    isTicketClosed: { type: Boolean, default: false },
    resource: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
    isGeolocationSupported: { type: Boolean, default: false },
  },
  computed: {
    dueByComputed() {
      return Math.abs(this.resource.dueBy)
    },
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>
